import AlertMixin from './alert'
import AuthMixin from './auth'
import BaseMixin from './base'
import BaseSlimMixin from './base-slim'
import MashupBuilderMixin from './mashup-builder'
import CartMixin from './cart'
import CartBookingItemMixin from './cart/items/booking'
import ComplexComponentMixin from './components/complex'
import ComponentMixin from './component'
import ConfigMixin from './config'
import DatesMixin from './dates'
import DynamicSectionsMixin from './dynamic/sections'
import EventsMixin from './events'
import FormMixin from './form'
import LangMixin from './lang'
import PageComponentMixin from './components/page'
import PagesMixin from './pages'
import ProcessorMixin from './processor'
import ProfileMixin from './profile'
import ProfileCardsMixin from './profile/cards'
import ResponsiveMixin from './responsive'
import ScrollerMixin from './scroller'
import ServiceMixin from './service'
import SettingsMixin from './settings'
import TimerMixin from './timer'
import ToastAlertMixin from './toast-alert'
import UtilsMixin from './utils'
import ValidationMixin from './validation'

export default {
  AlertMixin,
  AuthMixin,
  BaseMixin,
  BaseSlimMixin,
  MashupBuilderMixin,
  CartMixin,
  CartBookingItemMixin,
  ComplexComponentMixin,
  ComponentMixin,
  ConfigMixin,
  DatesMixin,
  DynamicSectionsMixin,
  EventsMixin,
  FormMixin,
  LangMixin,
  PageComponentMixin,
  PagesMixin,
  ProcessorMixin,
  ProfileMixin,
  ProfileCardsMixin,
  ResponsiveMixin,
  ScrollerMixin,
  ServiceMixin,
  SettingsMixin,
  TimerMixin,
  ToastAlertMixin,
  UtilsMixin,
  ValidationMixin,
}
